import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next' // Import useTranslation hook

import Auth from './components/Auth'
import Overview from './components/Overview'
import ProtectedRoute from './ProtectedRoute'
import Layout from './Layout'
import Documents from './components/Documents'

// Existing components
import Inbox from './components/Inbox'
import ListingManagement from './components/ListingManagement'

// New multi‑listing pages
// import ListingsForSale from './components/ListingsForSale'
// import ListingsForRent from './components/ListingsForRent'
import ManageListings from './components/ManageListings'
import DiscoverListings from './components/discover/DiscoverListings'
import Settings from './components/settings/Settings'
import LandingPage from './components/marketing/LandingPage'
import Blog from './components/marketing/Blog'
import AnalyticsDashboard from './components/analytics/AnalyticsDashboard'
import NotificationsMain from './components/watchlist/NotificationsMain'

function App() {
  const { t } = useTranslation() // Hook for translations

  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/auth" element={<Auth />} />

        {/* Protected routes with layout */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/blog/:id" element={<Blog />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout>
                <Overview />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/documents"
          element={
            <ProtectedRoute>
              <Layout>
                <Documents />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/user"
          element={
            <ProtectedRoute>
              <Layout>
                <Settings />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Layout>
                <Settings />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/notifications"
          element={
            <ProtectedRoute>
              <Layout>
                <NotificationsMain />
              </Layout>
            </ProtectedRoute>
          }
        />
        {/* Single listing management page */}
        <Route
          path="/listing/:listingId"
          element={
            <ProtectedRoute>
              <Layout>
                <ListingManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        {/* New multi-listing pages */}
        <Route
          path="/listings"
          element={
            <ProtectedRoute>
              <Layout>
                <ManageListings />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/discover"
          element={
            <ProtectedRoute>
              <Layout>
                <DiscoverListings />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/discover/:notificationId"
          element={
            <ProtectedRoute>
              <Layout>
                <DiscoverListings />
              </Layout>
            </ProtectedRoute>
          }
        />
        {/* Inbox route */}
        <Route
          path="/inbox"
          element={
            <ProtectedRoute>
              <Layout>
                <Inbox />
              </Layout>
            </ProtectedRoute>
          }
        />
        {/* Test analytics route */}
        <Route
          path="/analytics"
          element={
            <AnalyticsDashboard />

            // <ProtectedRoute>
            //   <Layout>
            //   </Layout>
            // </ProtectedRoute>
          }
        />

        {/* Catch-all for undefined routes */}
        <Route
          path="*"
          element={
            <Box sx={{ textAlign: 'center', mt: 4 }}>
              <Typography variant="h4" color="error">
                {t('notFound.title')}
              </Typography>
              <Typography variant="body1">{t('notFound.message')}</Typography>
            </Box>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}

export default App
